import { render, staticRenderFns } from "./QuickShip.vue?vue&type=template&id=663dd11a&scoped=true&"
import script from "./QuickShip.vue?vue&type=script&lang=ts&"
export * from "./QuickShip.vue?vue&type=script&lang=ts&"
import style0 from "./QuickShip.vue?vue&type=style&index=0&id=663dd11a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663dd11a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VDialog})
